import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AutoScrollDirective } from "./auto-scroll.directive";
import { LazyLoaderDirective } from "./lazy-loader.directive";
import { MailToDirective } from "./mail-to.directive";
import { NumberInputDirective } from "./number-input.directive";
import { TextAreaDirective } from "./text-area.directive";
import { InputTrimDirective } from "./input-trim.directive";
import { ObjectWatcherDirective } from "./object-watcher.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [
    AutoScrollDirective,
    LazyLoaderDirective,
    MailToDirective,
    NumberInputDirective,
    TextAreaDirective,
    InputTrimDirective,
    ObjectWatcherDirective
  ],
  exports: [
    AutoScrollDirective,
    LazyLoaderDirective,
    MailToDirective,
    NumberInputDirective,
    TextAreaDirective,
    InputTrimDirective,
    ObjectWatcherDirective
  ]
})
export class DirectiveModule {}
